import { BottleTonicPlusOutlineIcon } from './BottleTonicPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 8508B85B-4238-4FC5-90F8-3C7E5612174B
 * name bottle-tonic-plus-outline
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bottle-tonic-plus-outline.svg
 * tags
 * - Gaming / RPG 
 */
export const HealthPotionOutlineIcon = BottleTonicPlusOutlineIcon;
export default HealthPotionOutlineIcon